import React from "react";
import { Button, useTheme, useMediaQuery } from "@mui/material";
import { withStyles } from "@mui/styles";

const styles = {
  customButton: {
    fontFamily: "Open Sans Condensed Light, sans-serif",
    fontSize: "14px", //"13px", //"16px",
    color: "#4D4D4D",
  },
  customButtonMobile: {
    fontFamily: "Open Sans Condensed Light, sans-serif",
    fontSize: "14px", //"10px", //"16px",
    color: "#4D4D4D",
  },
};
function CustomButton(props) {
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));

  const { classes, ...rest } = props;

  return (
    <Button
      style={{ color: "#4D4D4D" }}
      className={isBelowMd ? classes.customButtonMobile : classes.customButton}
      {...rest}
    />
  );
}

export default withStyles(styles)(CustomButton);
